import type { ReactNode } from 'react'

interface StickyFooterProps {
  children: ReactNode
}

// Action bar pinned to the bottom of the page
export function StickyFooter({ children }: StickyFooterProps) {
  return (
    <div className="sticky right-0 bottom-0 left-0 z-10 flex w-full items-center justify-center gap-4 bg-linear-to-b from-transparent from-0% via-white via-19% to-white to-100% px-6 py-4 pt-6 md:flex md:justify-end md:gap-2.5 md:bg-indigo-50 md:from-indigo-50 md:from-100% md:via-indigo-50 md:to-indigo-50 md:px-21.5 md:py-4 md:pt-4">
      {children}
    </div>
  )
}
